export const COLORS = ['white', 'orange', 'red', 'lightPurple'];
